<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                
                <pageaddheader :title="title" :title1="title1" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        
                        <div class="table-responsive">
                            <a-table :columns="columns" :loading="loading" :data-source="filteredData" @change="onChange" :row-selection="rowSelection" row-key="no">
                                <template #bodyCell="{ column, record }">
                                    
                                    
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'tanggal'">
                                        <div class="productimgname">
                                            <span v-html="record.tanggal.replace(/ /g, '<br>')"></span>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'judul'">
                                        <div style="white-space: pre-line;">
                                            <div>{{ record.judul }}</div>
                                            <div>{{ record.konten }}</div>
                                        </div>
                                    </template>

                                    <template v-if="column.key === 'status_text'">
                                        <div class="productimgname">
                                            <a href="javascript:void(0);"
                                                :class="{ 'text-warning': record.status_text == 'PENDING', 'text-success': record.status_text == 'APPROVE', 'text-danger': record.status_text == 'REJECTED' }">{{
                                                record.status_text }}</a>
                                        </div>
                                    </template>
                                    <!-- <template v-if="column.key === 'konten'">
                                        <div
                                            style="min-height: 200px; max-height: 200px; white-space: pre-line; overflow-y: auto;">
                                            {{ record.konten }}
                                        </div>
                                    </template> -->
                                    <template v-if="column.key === 'lampiran'">
                                        <a :href="record.lampiran" class="product-img"
                                            v-if="checkFileType(record.lampiran) == 'image'">
                                            <img :src="record.lampiran" alt="document" />
                                        </a>
                                        <a :href="record.lampiran" class="product-img"
                                            v-if="checkFileType(record.lampiran) == 'pdf'">
                                            <vue-feather type="file-text"></vue-feather>
                                        </a>
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <!-- <a class="me-3 text-danger text-center d-block"
                                            @click="prosesCancel(record.token_old, record.jenis_form)"
                                            v-if="(record.status_text === 'APPROVE' && record.token_old !== '') || record.token_old === null"
                                            >
                                            <vue-feather type="slash"></vue-feather>
                                        </a>
                                        <a class="me-5 text-success"
                                            @click="openApprovalModal"  v-if="selectedRowKeys.length > 0 && record.status_text === 'PENDING'"
                                            style="font-size: 32px;">
                                            <i class='bx bx-user-check'></i>
                                        </a> -->
                                        <a class="me-3 text-danger"
                                            @click="proses(record.token, 'TOLAK', record.jenis_form)"
                                            v-if="record.token != ''">
                                            <vue-feather type="x"></vue-feather>
                                        </a>
                                        <a class="me-3" @click="proses(record.token, 'YA', record.jenis_form)"
                                            v-if="record.token != ''">
                                            <vue-feather type="check"></vue-feather>
                                        </a>

                                       
                                    </template>
                                </template>
                                <template #loading><a-spin size="large" /></template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>

    <!-- MODAL FOR APPROVAL  -->
    <div class="modal fade" id="openApproval" ref="openApproval" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Approval</h5>
                    <button type="button" class="close" @click="hideModal2('openApproval')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!-- <form @submit.prevent="approvalNotification"> -->
                    <div class="modal-body">
                        <div class="form-group d-flex flex-column gap-2">
                            <h5>
                                are you sure to bulk process <b>{{ selectedRowKeys.length }}</b>
                                data ?
                            </h5>
                            
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <!-- <button type="button" class="btn btn-sm btn-secondary" @click="hideModal2('openApproval')">cancel</button> -->
                        <button type="button" class="btn btn-sm btn-success" @click="confirmApproval('YA')" style="font-size: 24px;"><i class='bx bx-check'></i></button>
                        <button type="button" class="btn btn-sm btn-danger" @click="confirmApproval('TOLAK')" style="font-size: 24px;"><i class='bx bx-x'></i></button>
                    </div>
                <!-- </form> -->
            </div>
        </div>
    </div>
   
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, openInNewTab } from "@/assets/js/function";
import { watch } from 'vue';

export default {
    data() {
        return {
            filter: false,
            loading: false,
            title: "Approval List",
            title1: "Manage Approval",
            

            //data
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Date",
                    dataIndex: "tanggal",
                    key: "tanggal",
                    sorter: {
                        compare: (a, b) => {
                            a = a.tanggal.toLowerCase();
                            b = b.tanggal.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Title",
                    dataIndex: "judul",
                    key: "judul",
                    sorter: {
                        compare: (a, b) => {
                            a = a.judul.toLowerCase();
                            b = b.judul.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Type of Form",
                    dataIndex: "jenis_form",
                    key: "jenis_form",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jenis_form.toLowerCase();
                            b = b.jenis_form.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Document",
                    dataIndex: "lampiran",
                    key: "lampiran",
                    sorter: {
                        compare: (a, b) => {
                            a = a.lampiran.toLowerCase();
                            b = b.lampiran.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Status",
                    dataIndex: "status_text",
                    key: "status_text",
                    sorter: {
                        compare: (a, b) => {
                            a = a.status_text.toLowerCase();
                            b = b.status_text.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Action Trigger",
                    key: "action",
                    sorter: false,
                    fixed: 'right',
                },
            ],
            query: "",

            selectedRowKeys: [],
            selectedRows: [],
            approvalAction: null, // 'YA' | 'TOLAK'

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }

        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        this.index();
    },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {
                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            return this.data.filter(item =>
                item.tanggal.toLowerCase().includes(lowerCaseQuery) ||
                item.judul.toLowerCase().includes(lowerCaseQuery) ||
                item.konten.toLowerCase().includes(lowerCaseQuery) ||
                item.status_text.toLowerCase().includes(lowerCaseQuery)
            );
        },

        rowSelection() {
            return {
            selectedRowKeys: this.selectedRowKeys,
            getCheckboxProps: (record) => ({
                disabled: record.status_text !== 'PENDING',
            }),
            onChange: (keys, rows) => {
                this.selectedRowKeys = keys;
                this.selectedRows = rows;
            },
            };
        },
    },
    methods: {
       
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },


        openApprovalModal() {
            if (this.selectedRowKeys.length === 0) {
            AlertPopup2("warning", "", "Select at least one PENDING data", false, 1500);
            return;
            }

            this.showModal('openApproval');
        },

        async confirmApproval(action) {
            this.hideModal2('openApproval');

            await this.prosesBulk(action);
        },

        checkFileType(url) {
            if (url != null) {


                const extension = url.split('.').pop().toLowerCase();

                if (extension.match(/(jpg|jpeg|png)$/)) {
                    return 'image';
                } else if (extension === 'pdf') {
                    return 'pdf';
                } else {
                    return 'unknown';
                }
            } else {
                return 'unknown';
            }
        },

        confirmApproval(action) {
            this.hideModal2('openApproval');

            if (action === 'YA') {
            this.prosesBulk('YA');
            } else {
            this.prosesBulk('TOLAK');
            }
        },

        confirmCancel() {
            this.hideModal2('openApproval');
            this.prosesCancelBulk();
        },

        async prosesBulk(action) {
            if (this.selectedRows.length === 0) return;

            this.loading = true;

            for (const row of this.selectedRows) {
                // APPROVE / REJECT use same API
                await this.proses(row.token, action, row.jenis_form, true);
            }

            // clear selection
            this.selectedRowKeys = [];
            this.selectedRows = [];

            this.loading = false;
        },

        async prosesCancelBulk() {
            if (this.selectedRows.length === 0) return;

            this.loading = true;

            for (const row of this.selectedRows) {
                if (row.token_old) {
                await this.prosesCancel(row.token_old, row.jenis_form, true);
                }
            }

            this.selectedRowKeys = [];
            this.selectedRows = [];

            this.loading = false;
        },




        async index() {
            this.loading = true;
           
            let formData = new FormData();
            appendForm(formData)

            formData.append("jenis", 'pengajuan');

            const api = base_url + '/v3/notification/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const approval = data.data.data_notifikasi;
            console.log('ini data approval:', data)
            
            if(data.status){
                this.data = [];

                approval.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

                this.loading = false;

                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
                this.loading = false;

            }

           

        },
        
        // async proses(token, value, jenis_form) {
            
        //     let formData = new FormData();
        //     appendForm(formData)

        //     formData.append("token", token);
        //     formData.append("setuju", value);

        //     // let url = 'proses_' + jenis_form.toLowerCase();

        //     const urlMap = {
        //         izin: "/v3/notification/proses_izin",
        //         cuti: "/v3/notification/proses_cuti",
        //         lembur: "/v3/notification/proses_lembur",
        //     };

        //     const jenisKey = jenis_form.toLowerCase();

        //     if (!urlMap[jenisKey]) {
        //         AlertPopup2("error", "", "Jenis form tidak dikenal: " + jenis_form, false, 1500);
        //         return;
        //     }

        //     const api = base_url + urlMap[jenisKey];
        //     const res = await axios.post(api, formData, { timeout });
        //     const data = res.data;
        //     console.log('ini data approval:', data)
        //     // const proses = data.data.data_notifikasi;
            
        //     if(data.status){
        //         // Update semua record yang token-nya sama
        //         const sameToken = token;
        //         this.data.forEach((item, idx) => {
        //             if (item.token === sameToken) {
        //                 let updatedItem = { ...item };

        //                 if (value === "YA") {
        //                     updatedItem.status_text = 'APPROVE';
        //                     updatedItem.token = "";
        //                     updatedItem.token_old = token;
        //                     updatedItem.judul = item.judul.replace('[MENUNGGU]', '[DISETUJUI]');
        //                 } else if (value === "TOLAK") {
        //                     updatedItem.status_text = 'REJECTED';
        //                     updatedItem.token = "";
        //                     updatedItem.token_old = token;
        //                     updatedItem.judul = item.judul.replace('[MENUNGGU]', '[DITOLAK]');
        //                 }

        //                 this.data.splice(idx, 1, updatedItem);
        //                 AlertBottom( data.message || 'Success');
        //             }
        //         });

                
        //     }else {
        //         AlertPopup2("error", "", data.message, true, 1500);
        //         this.loading = false;

        //     }

            
        // },

        async proses(token, value, jenis_form) {

            // detect bulk mode
            const isBulk = this.selectedRows && this.selectedRows.length > 0;

            // build list of rows to process
            const rows = isBulk
                ? this.selectedRows
                : [{ token, jenis_form }];

            this.loading = true;

            let errorCount = 0;
            let errorMessages = [];

            for (const row of rows) {

                if (!row.token) continue;

                let formData = new FormData();
                appendForm(formData);

                formData.append("token", row.token);
                formData.append("setuju", value);

                const urlMap = {
                    izin: "/v3/notification/proses_izin",
                    cuti: "/v3/notification/proses_cuti",
                    lembur: "/v3/notification/proses_lembur",
                };

                const jenisKey = row.jenis_form.toLowerCase();

                if (!urlMap[jenisKey]) {
                    errorCount++;
                    errorMessages.push(`Jenis form tidak dikenal (${row.jenis_form})`);
                    continue;
                }

                const api = base_url + urlMap[jenisKey];

                try {
                    const res = await axios.post(api, formData, { timeout });
                    const data = res.data;

                    if (!data.status) {
                        errorCount++;
                        errorMessages.push(data.message || `Gagal memproses token ${row.token}`);
                        continue;
                    }

                    // update table (success still updates immediately)
                    this.data.forEach((item, idx) => {
                        if (item.token === row.token) {

                            let updatedItem = { ...item };

                            if (value === "YA") {
                                updatedItem.status_text = "APPROVE";
                                updatedItem.judul = item.judul.replace("[MENUNGGU]", "[DISETUJUI]");
                            } else {
                                updatedItem.status_text = "REJECTED";
                                updatedItem.judul = item.judul.replace("[MENUNGGU]", "[DITOLAK]");
                            }

                            updatedItem.token_old = row.token;
                            updatedItem.token = "";

                            this.data.splice(idx, 1, updatedItem);
                        }
                    });

                } catch (err) {
                    errorCount++;
                    errorMessages.push(err.message || `Terjadi kesalahan (token ${row.token})`);
                }
            }

            this.loading = false;

            // clear selection after bulk
            if (isBulk) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
            }

            // show result summary ONCE
            if (errorCount > 0) {
                AlertPopup2(
                    "error",
                    "",
                    // `${errorCount} data gagal diproses:\n\n${errorMessages.join("\n")}`,
                    `${errorCount} data gagal diproses`,
                    true,
                    3000
                );
            } else {
                AlertBottom("Semua data berhasil diproses");
            }
        },

        async prosesCancel(token_old, jenis_form) {

            // detect bulk mode
            const isBulk = this.selectedRows && this.selectedRows.length > 0;

            // build list of rows to process
            const rows = isBulk
                ? this.selectedRows
                : [{ token_old, jenis_form }];

            this.loading = true;

            let errorCount = 0;
            let errorMessages = [];

            for (const row of rows) {

                if (!row.token_old) continue;

                let formData = new FormData();
                appendForm(formData);

                formData.append("token_old", row.token_old);
                formData.append("jenis_form", row.jenis_form);

                const urlMap = {
                    izin: "/v3/notification/proses_cancel_izin",
                    cuti: "/v3/notification/proses_cancel_cuti",
                    lembur: "/v3/notification/proses_cancel_lembur",
                };

                const jenisKey = row.jenis_form.toLowerCase();

                if (!urlMap[jenisKey]) {
                    errorCount++;
                    errorMessages.push(`Jenis form tidak dikenal (${row.jenis_form})`);
                    continue;
                }

                const api = base_url + urlMap[jenisKey];

                try {
                    const res = await axios.post(api, formData, { timeout });
                    const data = res.data;

                    if (!data.status) {
                        errorCount++;
                        errorMessages.push(data.message || `Gagal cancel token ${row.token_old}`);
                        continue;
                    }

                    // update table (success)
                    this.data.forEach((item, idx) => {
                        if (item.token_old === row.token_old) {

                            const updatedItem = {
                                ...item,
                                status_text: "REJECTED",
                                judul: item.judul.replace("[DISETUJUI]", "[DITOLAK]")
                            };

                            this.data.splice(idx, 1, updatedItem);
                        }
                    });

                } catch (err) {
                    errorCount++;
                    errorMessages.push(err.message || `Terjadi kesalahan (token ${row.token_old})`);
                }
            }

            this.loading = false;

            // clear selection after bulk
            if (isBulk) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
            }

            //  show summary result ONCE
            if (errorCount > 0) {
                AlertPopup2(
                    "error",
                    "",
                    `${errorCount} data gagal dibatalkan:\n\n${errorMessages.join("\n")}`,
                    true,
                    3000
                );
            } else {
                AlertBottom("Semua data berhasil dibatalkan");
            }
        },



        // async prosesCancel(token_old, jenis_form) {
            
        //     let formData = new FormData();
        //     appendForm(formData)

        //     formData.append("token_old", token_old);
        //     formData.append("jenis_form", jenis_form);

        //     const urlMap = {
        //         izin: "/v3/notification/proses_cancel_izin",
        //         cuti: "/v3/notification/proses_cancel_cuti",
        //         lembur: "/v3/notification/proses_cancel_lembur",
        //     };

        //     const jenisKey = jenis_form.toLowerCase();

        //     if (!urlMap[jenisKey]) {
        //         AlertPopup2("error", "", "Jenis form tidak dikenal: " + jenis_form, false, 1500);
        //         return;
        //     }

        //     const api = base_url + urlMap[jenisKey];
        //     const res = await axios.post(api, formData, { timeout });
        //     const data = res.data;
        //     console.log('ini data proses cancel:', data)
        //     // const proses = data.data.data_notifikasi;
            
        //     if(data.status){
        //         // Update semua record yang token_old-nya sama
        //         const sameTokenOld = token_old;
        //         this.data.forEach((item, idx) => {
        //             if (item.token_old === sameTokenOld) {
        //                 const updatedItem = {
        //                     ...item,
        //                     status_text: 'REJECTED',
        //                     judul: item.judul.replace('[DISETUJUI]', '[DITOLAK]')
        //                 };
        //                 this.data.splice(idx, 1, updatedItem);
        //             }
        //         });

        //         // Tampilkan alert + redirect
        //         AlertBottom(data.message || 'Berhasil diproses');

        //     }else {
        //         AlertPopup2("error", "", data.message, true, 1500);
        //         this.loading = false;

        //     }

        // },

        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },
        terminate(id, nama) {
            this.id_terminate = id;
            this.nama_terminate = nama;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
.ant-spin {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}
</style>